import { render, staticRenderFns } from "./userInfoAndInsuranceCompany.vue?vue&type=template&id=e5967a8c&"
import script from "./userInfoAndInsuranceCompany.vue?vue&type=script&lang=js&"
export * from "./userInfoAndInsuranceCompany.vue?vue&type=script&lang=js&"
import style0 from "./userInfoAndInsuranceCompany.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports